module.exports = __webpack_public_path__ + "img/和风.b71f681c.png";